import { render, staticRenderFns } from "./Classrooms.vue?vue&type=template&id=6ab0a1ee&scoped=true&"
import script from "./Classrooms.vue?vue&type=script&lang=js&"
export * from "./Classrooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab0a1ee",
  null
  
)

export default component.exports